<template>
  <div v-if="hasErrors">
    <v-alert
      v-for="(error, index) in errors"
      :key="index"
      color="error"
      dark
      dense
    >
      {{ error }}
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'Errors',

  props: {
    errors: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    hasErrors() {
      return this.errors.length > 0;
    }
  }
};
</script>

<style scoped></style>
